import { motion } from "motion/react";
import { Mail, Briefcase, Compass, Cpu } from "lucide-react";
import { useLanguage } from "./LanguageContext";

export default function Careers() {
  const { t } = useLanguage();
  
  const perksData = t("perks", "careers") || [];
  const icons = [<Compass size={16} />, <Cpu size={16} />, <Briefcase size={16} />];
  const perks = perksData.map((p: any, idx: number) => ({
    icon: icons[idx] || <Briefcase size={16} />,
    title: p.title,
    text: p.text
  }));

  return (
    <section id="careers" className="relative py-24 md:py-32 bg-[#FAFAFC] overflow-hidden">
      {/* Wave mesh abstract backdrop */}
      <div className="absolute inset-0 mesh-bg opacity-40 pointer-events-none" />

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        
        {/* Bento Board Grid block wrapper */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-stretch">
          
          {/* Main Card with Career Callout */}
          <div className="md:col-span-7 bg-white border border-gray-150 p-8 md:p-10 rounded-2xl flex flex-col justify-between shadow-xs text-left">
            <div className="flex flex-col gap-4">
              <span className="text-[10px] font-mono tracking-widest text-[#4F46E5] uppercase font-semibold">
                {t("tag", "careers")}
              </span>
              <h3 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-brand-charcoal">
                {t("title", "careers")}.
              </h3>
              <p className="text-gray-500 font-light text-sm leading-relaxed max-w-md">
                {t("desc", "careers")}
              </p>
            </div>

            <div className="mt-8 border-t border-gray-100 pt-6">
              {/* Mail action trigger link */}
              <motion.a
                href="mailto:careers@teralumax.com"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="group inline-flex items-center gap-2.5 text-xs font-mono tracking-widest bg-brand-charcoal text-white hover:bg-indigo-600 px-6.5 py-4 rounded-xl transition-all shadow-md hover:shadow-indigo-500/10 focus:outline-hidden cursor-pointer"
              >
                {t("applyCta", "careers")} <Mail size={13} className="group-hover:rotate-6 transition-transform" />
              </motion.a>
              <span className="block text-[10px] text-gray-500 font-mono mt-3">
                {t("applySub", "careers")}
              </span>
            </div>
          </div>

          {/* Side perks panel layout columns */}
          <div className="md:col-span-5 flex flex-col gap-4">
            {perks.map((perk, idx) => (
              <div
                key={idx}
                className="p-6 bg-white/40 border border-gray-150 backdrop-blur-md rounded-2xl flex items-start gap-4 flex-grow transition-all hover:bg-white text-left"
              >
                <div className="p-2.5 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
                  {perk.icon}
                </div>
                <div>
                  <h4 className="font-display font-semibold text-sm text-brand-charcoal mb-1">
                    {perk.title}
                  </h4>
                  <p className="text-gray-500 font-light text-xs leading-normal">
                    {perk.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
}
